import { Typography } from "@material-ui/core";
import millify from "millify";
import { useSelector } from "react-redux";

export default function BondsGrid(props) {
  const bonds = props.bonds;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const t = props.t;

  return (
    <>
      {bonds?.length > 0 ? (
        <div
          style={{
            width: isDesktopOrLaptop ? "757px" : "557px",
            padding: isDesktopOrLaptop ? 0 : "0 0 0 10px",
          }}
        >
          <div
            style={{
              padding: isDesktopOrLaptop ? "0 0px 0 60px" : "0",
              display: "flex",
              alignItems: "center",
              height: "41px",
            }}
          >
            <Typography
              style={{
                width: isDesktopOrLaptop ? "174px" : "139px",
                height: "18px",
                color: "#16063b",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "14px" : "12px",
                fontWeight: 600,
              }}
            >
              {t("name")}
            </Typography>
            <Typography
              style={{
                width: isDesktopOrLaptop ? "174px" : "139px",
                height: "18px",
                color: "#16063b",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "14px" : "12px",
                fontWeight: 600,
              }}
            >
              {t("issue_volume")}
            </Typography>
            <Typography
              style={{
                width: isDesktopOrLaptop ? "174px" : "139px",
                height: "18px",
                color: "#16063b",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "14px" : "12px",
                fontWeight: 600,
              }}
            >
              {t("currency")}
            </Typography>
            <Typography
              style={{
                width: "175px",
                height: "18px",
                color: "#16063b",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "14px" : "12px",
                fontWeight: 600,
              }}
            >
              {t("coupon")}
            </Typography>
          </div>
          {bonds?.map((bond, index) => {
            return (
              <div
                style={{
                  padding: isDesktopOrLaptop ? "0 0px 0 60px" : 0,
                  height: "41px",
                  display: "flex",
                  backgroundColor: index % 2 === 0 ? "#fcfcfc" : "",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    width: isDesktopOrLaptop ? "174px" : "139px",
                    height: "18px",
                    color: "#808080",
                    fontFamily: "Overpass",
                    fontSize: isDesktopOrLaptop ? "14px" : "12px",
                  }}
                >
                  {bond.nome
                    ? bond.nome?.length > 15
                      ? `${bond.nome?.substr(0, 15)}...`
                      : bond.nome
                    : bond.name?.length > 15
                    ? `${bond.name?.substr(0, 15)}...`
                    : bond.name}
                </Typography>
                <Typography
                  style={{
                    width: isDesktopOrLaptop ? "174px" : "139px",
                    height: "18px",
                    color: "#808080",
                    fontFamily: "Overpass",
                    fontSize: isDesktopOrLaptop ? "14px" : "12px",
                  }}
                >
                  {millify(
                    bond.issue_volume
                      ? bond.issue_volume
                      : bond.volume_di_emissione
                      ? bond.volume_di_emissione
                      : 0,
                    {
                      space: true,
                      precision: 3,
                    }
                  )}
                </Typography>
                <Typography
                  style={{
                    width: isDesktopOrLaptop ? "174px" : "139px",
                    height: "18px",
                    color: "#808080",
                    fontFamily: "Overpass",
                    fontSize: isDesktopOrLaptop ? "14px" : "12px",
                  }}
                >
                  {bond.currency ? bond.currency : bond.valuta}
                </Typography>
                <Typography
                  style={{
                    width: "175px",
                    height: "18px",
                    color: "#808080",
                    fontFamily: "Overpass",
                    fontSize: isDesktopOrLaptop ? "14px" : "12px",
                  }}
                >
                  {bond.coupon ? bond.coupon : bond.buono}
                </Typography>
              </div>
            );
          })}
          <div
            style={{
              width: isDesktopOrLaptop ? "100%" : "60px",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              marginLeft: isDesktopOrLaptop ? 0 : "40vw",
              marginBottom: "20px",
            }}
          >
            <Typography
              style={{
                color: "#0040ff",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "14px" : "12px",
                fontWeight: "bold",
                textDecoration: "underline",
                cursor: "pointer",
                display: "flex",
              }}
              onClick={() => {
                props.setCompanyDetail(props.ISIN);
              }}
            >
              View All
            </Typography>
          </div>
        </div>
      ) : null}
    </>
  );
}
